/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectPatternsQuery } from '../../models/get-project-patterns-query';
import { GetProjectPatternsQueryResult } from '../../models/get-project-patterns-query-result';

export interface ApiProjectStagesGetPatternsPost$Params {
      body?: GetProjectPatternsQuery
}

export function apiProjectStagesGetPatternsPost(http: HttpClient, rootUrl: string, params?: ApiProjectStagesGetPatternsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPatternsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectStagesGetPatternsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectPatternsQueryResult>;
    })
  );
}

apiProjectStagesGetPatternsPost.PATH = '/api/ProjectStages/GetPatterns';
